import { IAuthManager } from '../interface/IAuthManager.interface';
import { Auth, AuthProvider, UserCredential } from '@firebase/auth';
import { AuthUserInfo } from '../interface/auth.interface';

export class NoopAuthManager implements IAuthManager {
  readonly auth: Auth;

  clearAuthData(): void {}

  decodeToken(token: string): any {}

  getAccessToken(forceRefresh: boolean | undefined): Promise<string> {
    return Promise.resolve('');
  }

  getAuthProvider(provider: any): AuthProvider {
    return undefined;
  }

  getCurrentLocalStorageSpell(): string {
    return '';
  }

  getCurrentUser(): any {}

  getCustomClaims(forceRefresh: boolean | undefined): Promise<Partial<AuthUserInfo>> {
    return Promise.resolve(undefined);
  }

  getSignInCustomToken(): Promise<string> {
    return Promise.resolve('');
  }

  getUserInfo(forceRefresh: boolean | undefined): Promise<AuthUserInfo> {
    return Promise.resolve(undefined);
  }

  getUserRoles(): Promise<string[]> {
    return Promise.resolve([]);
  }

  handleCallback(): Promise<UserCredential | null> {
    return Promise.resolve(undefined);
  }

  handleRedirectResult(): Promise<any> {
    return Promise.resolve(undefined);
  }

  hasCustomToken(): boolean {
    return false;
  }

  haveLoggedIn(): Promise<boolean> {
    return Promise.resolve(false);
  }

  isBanned(): Promise<boolean> {
    return Promise.resolve(false);
  }

  isCompleteSignUp(): Promise<boolean> {
    return Promise.resolve(false);
  }

  isLoggedIn(): boolean {
    return false;
  }

  isPurchasesApp(app: string | undefined): Promise<boolean> {
    return Promise.resolve(false);
  }

  isWaitingForVerifyingPhone(): Promise<boolean> {
    return Promise.resolve(false);
  }

  login({ provider, afterLogin }: { provider: any; afterLogin: () => void }): void {}

  loginByLocalStorageString(localStorageString: string): void {}

  logout(withRedirect: boolean | undefined): void {}

  needVerifyPhone(): Promise<boolean> {
    return Promise.resolve(false);
  }

  onAuthStateChanged(nextOrObserver: any): any {}

  popupLogin(params: any): Promise<void> {
    return Promise.resolve(undefined);
  }

  refreshToken(): void {}

  saveHaveLoggedIn(): void {}

  saveLocalPhoneVerified(verified: boolean): void {}

  saveUserInfo(): void {}

  signInCustomToken(token: string | undefined): Promise<string> {
    return Promise.resolve('');
  }

  userForAccountLinking(provider: any): Promise<AuthUserInfo> {
    return Promise.resolve(undefined);
  }
}
